const defaultSizes = [
    { xs: 12, md: 4 },
    { xs: 12, md: 4 },
    { xs: 12, md: 4 },
];

const fisrtStyles = {
    order: { xs: 2, md: 1 },
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'center', lg: 'start' }
};

const secondStyles = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: { xs: 1, md: 2 },
};

const thirdStyles = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'center', md: 'end' },
    fontSize: '.8rem',
    order: 3,
};

const autocompleteStyles = {
    width: 'min(224px,100%)',
    background: 'white'
};

const defaultStyles = {
    fisrtStyles,
    secondStyles,
    thirdStyles,
    autocompleteStyles,
};

const defaultOptions = [5, 10, 15, 20];


export {
    defaultSizes,
    defaultStyles,
    defaultOptions,
};